export default {
    clientBanner: {
        title: 'Client Banner Config',
        subtitle: 'Config key: {key} · module: {module}',
        readOnly: 'You have view-only access. Grant Service Config Edit permission to make changes.',
        previewJson: 'Preview JSON',
        load: {
            failed: 'Failed to load banner config',
        },
        save: {
            success: 'Banner config saved',
            failed: 'Failed to save banner config',
            conflict:
                'Config was updated by someone else. Latest data has been reloaded; please review and save again.',
            removedDeleted:
                'Removed {count} unavailable drama(s) (deleted/offline/not in list) and saved config automatically',
        },
        upload: {
            success: 'Upload successful',
            failed: 'Upload failed',
        },
        settings: {
            enabled: 'Enabled',
            enabledRequiresItems: 'Select at least one drama before enabling Banner',
        },
        picker: {
            panelTitle: 'Drama catalog',
            search: 'Search by title or ID',
            onlineOnly: 'Online only',
            loaded: '{total} total',
            total: '{total} total',
            maxReached: 'You can select up to {max} banners',
            unavailable: 'Deleted or offline dramas cannot be added to Banner',
            select: 'Select',
            cover: 'Cover',
            title: 'Title',
            status: 'Status',
        },
        list: {
            title: 'Selected banners',
            count: '{count}/{max} selected',
            empty: 'Select dramas from the catalog on the left',
            missing: 'Drama not found',
            noImage: 'No image',
            uploadThumb: 'Upload thumbnail',
            customThumb: 'Custom image',
            usingDramaCover: 'Drama default',
            restoreDefault: 'Use drama default',
            thumbHint: 'Leave empty to use the drama default image',
        },
    },
};
